// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-caption-prefix {
  white-space: nowrap;
  padding-right: 2px;
}

.theia-caption-suffix {
  white-space: nowrap;
  padding: 0px 2px 0px 2px;
}

.theia-caption-suffix-tail {
  min-width: 1rem;
  text-align: center;
  font-size: var(--theia-ui-font-size0);
}

.theia-icon-wrapper {
  top: 0px !important;
  position: relative;
  display: inline-flex;
}

.theia-decorator-size {
  transform: scale(0.7);
  text-align: center;
  height: 100%;
  width: 100%;
}

.theia-decorator-sidebar-size {
  height: 100%;
  text-align: center;
  transform: scale(1.2);
  width: 100%;
}

.theia-top-right {
  position: absolute;
  bottom: 40%;
  left: 25%;
}

.theia-bottom-right {
  position: absolute;
  top: 40%;
  left: 25%;
}

.theia-bottom-right-sidebar {
  position: absolute;
  top: 80%;
  left: 50%;
}

.theia-bottom-left {
  position: absolute;
  top: 40%;
  right: 25%;
}

.theia-top-left {
  position: absolute;
  bottom: 40%;
  right: 25%;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/tree-decorators.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-caption-prefix {\n  white-space: nowrap;\n  padding-right: 2px;\n}\n\n.theia-caption-suffix {\n  white-space: nowrap;\n  padding: 0px 2px 0px 2px;\n}\n\n.theia-caption-suffix-tail {\n  min-width: 1rem;\n  text-align: center;\n  font-size: var(--theia-ui-font-size0);\n}\n\n.theia-icon-wrapper {\n  top: 0px !important;\n  position: relative;\n  display: inline-flex;\n}\n\n.theia-decorator-size {\n  transform: scale(0.7);\n  text-align: center;\n  height: 100%;\n  width: 100%;\n}\n\n.theia-decorator-sidebar-size {\n  height: 100%;\n  text-align: center;\n  transform: scale(1.2);\n  width: 100%;\n}\n\n.theia-top-right {\n  position: absolute;\n  bottom: 40%;\n  left: 25%;\n}\n\n.theia-bottom-right {\n  position: absolute;\n  top: 40%;\n  left: 25%;\n}\n\n.theia-bottom-right-sidebar {\n  position: absolute;\n  top: 80%;\n  left: 50%;\n}\n\n.theia-bottom-left {\n  position: absolute;\n  top: 40%;\n  right: 25%;\n}\n\n.theia-top-left {\n  position: absolute;\n  bottom: 40%;\n  right: 25%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
